function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
import Immutable from 'seamless-immutable';
import contains from 'ramda/src/includes';
import clone from 'ramda/src/clone';
import find from 'ramda/src/find';
import pathOr from 'ramda/src/pathOr';
import pluck from 'ramda/src/pluck';
import propEq from 'ramda/src/propEq';
import uniq from 'ramda/src/uniq';
import CustomerCareKeys from '../../locales/keys';
import { BILLER_RULE_INSTANCE_TYPE } from '../../customercare.constants';
import { populateAttributeGroups } from '../selected.offering.order.reducer';
import { populateDevice } from './offer.ordering.wizard.selector.helper';
export default (function () {
  var _recursivelyUpdateChainedAttributes = function recursivelyUpdateChainedAttributes(attributeGroup, attribute) {
    var dependentAttrsToUpdate = attributeGroup.reduce(function (depAttrs, otherAttribute) {
      var updatedAttr;
      if (otherAttribute.dependentServiceAttributeId === attribute.id) {
        if (otherAttribute.isHidden && !attribute.isHidden) {
          if (!otherAttribute.dependentValues) {
            updatedAttr = otherAttribute.set('isHidden', false);
          } else if (contains(attribute.formValue, otherAttribute.dependentValues)) {
            updatedAttr = otherAttribute.set('isHidden', false);
          }
        } else {
          if (attribute.isHidden) {
            updatedAttr = otherAttribute.set('isHidden', true);
          } else if (otherAttribute.dependentValues && !contains(attribute.formValue, otherAttribute.dependentValues)) {
            updatedAttr = otherAttribute.set('isHidden', true);
          }
        }
      }
      if (updatedAttr) {
        depAttrs.push(updatedAttr);
      }
      return depAttrs;
    }, []);
    var updatedGroup = dependentAttrsToUpdate.reduce(updateGroupWith, attributeGroup);
    return dependentAttrsToUpdate.reduce(_recursivelyUpdateChainedAttributes, updatedGroup);
  };
  var updateGroupWith = function updateGroupWith(attributeGroup, updatedAttribute) {
    return attributeGroup.map(function (attribute) {
      return attribute.id === updatedAttribute.id ? updatedAttribute : attribute;
    });
  };
  return {
    clearAttributeInventorySearching: function clearAttributeInventorySearching() {
      var attributeGroups = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      if (attributeGroups) {
        return attributeGroups.map(function (attributeGroup) {
          var attribute = attributeGroup.find(function (attr) {
            return attr.searchingInventory;
          });
          if (attribute) {
            var updatedAttribute = Object.assign({}, attribute, {
              searchingInventory: false
            });
            return updateGroupWith(attributeGroup, updatedAttribute);
          } else {
            return attributeGroup;
          }
        });
      } else {
        return [];
      }
    },
    clearStateFromOfferSelection: function clearStateFromOfferSelection(state, offerId, defaultCart) {
      var skippedSteps = state.skippedSteps;
      var completedSteps = state.completedSteps.asMutable();
      if (!offerId || offerId !== state.cart.selectedOfferId) {
        delete completedSteps[CustomerCareKeys.WIZARD.STEPS.OFFERS];
        delete completedSteps[CustomerCareKeys.WIZARD.STEPS.COMPARE_OFFERS];
        delete completedSteps[CustomerCareKeys.WIZARD.STEPS.DECISIONS];
        delete completedSteps[CustomerCareKeys.WIZARD.STEPS.ATTRIBUTES];
        skippedSteps = state.skippedSteps.filter(function (stepKey) {
          return stepKey !== CustomerCareKeys.WIZARD.STEPS.DECISIONS && stepKey !== CustomerCareKeys.WIZARD.STEPS.ATTRIBUTES;
        });
      }
      return state.set('subscriptionOrderQuote', defaultCart.subscriptionOrderQuote).set('quote', defaultCart.quote).setIn(['cart', 'editAttributeGroups'], defaultCart.editAttributeGroups).setIn(['cart', 'editPhysicalAttributeGroups'], defaultCart.editPhysicalAttributeGroups).setIn(['cart', 'selectedEditOption'], defaultCart.selectedEditOption).setIn(['cart', 'editOptions'], defaultCart.editOptions).set('completedSteps', completedSteps).set('skippedSteps', skippedSteps);
    },
    mergePhysicalAttributeGroups: function mergePhysicalAttributeGroups(newAttributes, existingAttributes) {
      var getAttribute = function getAttribute(pricingPlan, id, groups) {
        return find(propEq(id, 'id'))(groups[pricingPlan]);
      };
      var mergedAttributeGroups = {};
      var _loop = function _loop(pricingPlan) {
        newAttributes[pricingPlan].forEach(function (attribute) {
          if (!mergedAttributeGroups[pricingPlan]) {
            mergedAttributeGroups[pricingPlan] = [];
          }
          if (!existingAttributes[pricingPlan]) {
            mergedAttributeGroups[pricingPlan].push(populateDevice(attribute));
          } else {
            var existingAttribute = getAttribute(pricingPlan, attribute.id, existingAttributes);
            var item = existingAttribute ? existingAttribute : populateDevice(attribute);
            mergedAttributeGroups[pricingPlan].push(item);
          }
        });
      };
      for (var pricingPlan in newAttributes) {
        _loop(pricingPlan);
      }
      return mergedAttributeGroups;
    },
    setEditAttributeGroups: function setEditAttributeGroups(newAttributes, editCartAttributeGroups) {
      var populatedAttributeGroups = populateAttributeGroups(newAttributes);
      if (editCartAttributeGroups && editCartAttributeGroups.length && populatedAttributeGroups && populatedAttributeGroups.length) {
        populatedAttributeGroups.forEach(function (attributes) {
          for (var i = 0; i < attributes.length; i++) {
            var existingAttribute = getAttribute(attributes[i].id, editCartAttributeGroups);
            if (existingAttribute) {
              var existingAttributeWithOrderScenario = Object.assign({}, existingAttribute, {
                parentServicePlanOrderScenario: attributes[i].parentServicePlanOrderScenario
              });
              if (attributes[i].inventoryItemReservation) {
                attributes[i] = Object.assign({}, existingAttributeWithOrderScenario, {
                  inventoryItemReservation: attributes[i].inventoryItemReservation
                });
              } else {
                attributes[i] = existingAttributeWithOrderScenario;
              }
            }
          }
        });
      }
      return populatedAttributeGroups;
    },
    getRecurringTotal: function getRecurringTotal(payload) {
      var hasRecurring = payload.ShoppingCart.BillerRuleTotals.find(function (total) {
        return total.Type === BILLER_RULE_INSTANCE_TYPE.RECURRING;
      });
      return hasRecurring ? hasRecurring.TotalAmount : 0;
    },
    restoreDefaultOptionPricing: function restoreDefaultOptionPricing(state, payload) {
      return state.setIn(['editCart', 'editOptions'], _restoreDefaultOptionPricing(state.editCart.editOptions, payload));
    },
    setAttributeInventorySearching: function setAttributeInventorySearching(attributeGroups, attributeId) {
      if (attributeGroups) {
        return attributeGroups.map(function (attributeGroup) {
          var attribute = attributeGroup.find(function (attr) {
            return attr.id === attributeId;
          });
          if (attribute) {
            var updatedAttribute = Object.assign({}, attribute, {
              searchingInventory: true
            });
            return updateGroupWith(attributeGroup, updatedAttribute);
          } else {
            return attributeGroup;
          }
        });
      } else {
        return [];
      }
    },
    setEditOption: function setEditOption(state, payload) {
      return state.setIn(['editCart', 'editOptions'], _setEditOption(state.editCart.editOptions, payload)).setIn(['editCart', 'selectedEditOption'], payload.Id);
    },
    setOrderQuote: function setOrderQuote(payload) {
      return pathOr({}, ['Quote', 'Totals'], payload);
    },
    setPaymentInfo: function setPaymentInfo(state, payload) {
      return state.setIn(['cart', 'paymentInfo'], payload);
    },
    setSelectedFacetsEditCopy: function setSelectedFacetsEditCopy(state, payload) {
      return state.merge({
        editCart: {
          selectedFacetIds: payload.isSelected ? uniq(state.editCart.selectedFacetIds.concat([payload.facetId])) : state.editCart.selectedFacetIds.filter(function (id) {
            return id !== payload.facetId;
          })
        }
      }, {
        deep: true
      });
    },
    setSelectedOfferingChargeTypesEditCopy: function setSelectedOfferingChargeTypesEditCopy(state, payload) {
      return state.merge({
        editCart: {
          selectedOfferingChargeTypeIds: payload.isSelected ? uniq(state.editCart.selectedOfferingChargeTypeIds.concat([payload.offeringChargeTypeId])) : state.editCart.selectedOfferingChargeTypeIds.filter(function (id) {
            return id !== payload.offeringChargeTypeId;
          })
        }
      }, {
        deep: true
      });
    },
    setServiceAddress: function setServiceAddress(state, payload) {
      return state.set('serviceAddress', find(propEq(true, 'DefaultService'))(payload.Addresses || []));
    },
    transformAttributeGroups: function transformAttributeGroups(payload) {
      return Immutable(payload).map(function (attrGroup) {
        var parentAttrsWithDependentsIds = attrGroup.filter(function (attr) {
          return !!attr.dependentServiceAttributeId;
        }).map(function (attr) {
          return attr.dependentServiceAttributeId;
        });
        var parentAttrsWithDependents = attrGroup.filter(function (attr) {
          return !attr.dependentServiceAttributeId && parentAttrsWithDependentsIds.includes(attr.id);
        });
        return parentAttrsWithDependents.reduce(_recursivelyUpdateChainedAttributes, attrGroup);
      });
    },
    updateAttributeGroups: function updateAttributeGroups(attributeGroups, attributeId, formValue) {
      if (attributeGroups) {
        return attributeGroups.map(function (attributeGroup) {
          var attribute = attributeGroup.find(function (attr) {
            return attr.id === attributeId;
          });
          if (attribute) {
            var updatedAttribute = attribute.set('formValue', formValue);
            var updatedGroup = updateGroupWith(attributeGroup, updatedAttribute);
            return _recursivelyUpdateChainedAttributes(updatedGroup, updatedAttribute);
          } else {
            return attributeGroup;
          }
        });
      } else {
        return [];
      }
    },
    updateAttributePortInRequest: function updateAttributePortInRequest(attributeGroups, attributeId, portInData, token, address) {
      return !attributeGroups ? [] : attributeGroups.map(function (attributeGroup) {
        var attribute = attributeGroup.find(function (attr) {
          return attr.id === attributeId;
        });
        if (!attribute) {
          return attributeGroup;
        }
        var updatedAttribute = Object.assign({}, attribute, {
          mnpToken: token,
          address: address,
          portInRequest: Object.assign({}, attribute.portInRequest, {
            portInData: portInData
          })
        });
        var updatedGroup = updateGroupWith(attributeGroup, updatedAttribute);
        return _recursivelyUpdateChainedAttributes(updatedGroup, updatedAttribute);
      });
    },
    sendPortInOrItemReservation: function sendPortInOrItemReservation(completedDecisions, attributeId, sendPortInReservation) {
      return !completedDecisions ? [] : completedDecisions.map(function (decision) {
        var attribute = decision.find(function (attr) {
          return attr.id === attributeId;
        });
        if (attribute) {
          var updatedAttribute = Object.assign({}, attribute, {
            passPortIn: sendPortInReservation
          });
          var updatedGroup = updateGroupWith(decision, updatedAttribute);
          return _recursivelyUpdateChainedAttributes(updatedGroup, updatedAttribute);
        } else {
          return decision;
        }
      });
    },
    updateAttributeInventoryOptions: function updateAttributeInventoryOptions() {
      var attributeGroups = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var options = arguments.length > 1 ? arguments[1] : undefined;
      if (attributeGroups) {
        return attributeGroups.map(function (attributeGroup) {
          var attribute = attributeGroup.find(function (attr) {
            return attr.searchingInventory;
          });
          if (attribute) {
            var mappedOptions = options.map(function (option) {
              return {
                instanceId: option.InstanceId,
                inventoryStateId: option.InventoryStateId,
                isPreferred: option.IsPreferred,
                serialNumber: option.SerialNumber
              };
            });
            var optionsIncludesSelectedValue = mappedOptions.find(function (option) {
              return option.serialNumber === attribute.selectedValue;
            });
            var updatedAttribute = Object.assign({}, attribute, {
              searchingInventory: false,
              inventoryItemReservation: Object.assign({}, attribute.inventoryItemReservation, {
                options: attribute.selectedValue && !optionsIncludesSelectedValue ? [{
                  serialNumber: attribute.selectedValue
                }].concat(_toConsumableArray(mappedOptions)) : mappedOptions
              })
            });
            return updateGroupWith(attributeGroup, updatedAttribute);
          } else {
            return attributeGroup;
          }
        });
      } else {
        return [];
      }
    },
    updateDeliveryDecision: function updateDeliveryDecision(state, payload) {
      var deliveryDecisions = clone(state.editCart.deliveryDecisions);
      deliveryDecisions && deliveryDecisions.forEach(function (item) {
        if (item.Shippable) {
          return item.SelectedValue = payload.selectedValue;
        }
      });
      return deliveryDecisions;
    },
    updateserviceTaxLocationDecision: function updateserviceTaxLocationDecision(state, payload) {
      if (payload) {
        var serviceTaxDecisions = clone(state.editCart.serviceTaxDecisions);
        serviceTaxDecisions.forEach(function (item) {
          item.ServiceTaxCustomization = payload[item.PricingPlanId][item.InstanceNumber].ServiceTaxCustomization;
          item.selectedTaxOption = payload[item.PricingPlanId][item.InstanceNumber].taxOption;
        });
        return serviceTaxDecisions;
      }
    },
    updateBillCycle: function updateBillCycle(state, payload) {
      return state.setIn(['editCart', 'billCycle'], payload);
    },
    updateInventorySelection: function updateInventorySelection(attributeGroups, payload) {
      if (attributeGroups) {
        return attributeGroups.map(function (attributeGroup) {
          var attribute = attributeGroup.find(function (attr) {
            return attr.id === payload.attributeId;
          });
          if (attribute) {
            var updatedReservation = attribute.inventoryItemReservation ? attribute.inventoryItemReservation.set('instanceId', payload.InventoryItem.instanceId || payload.InventoryItem.InstanceId).set('serialNumber', undefined).set('token', attribute.inventoryItemReservation ? attribute.inventoryItemReservation.token : undefined) : {
              instanceId: payload.InventoryItem.instanceId || payload.InventoryItem.InstanceId,
              serialNumber: undefined,
              token: undefined
            };
            var updatedAttribute = attribute.set('formValue', payload.formValue).set('selectedValue', payload.formValue).set('inventoryItemReservation', updatedReservation);
            return updateGroupWith(attributeGroup, updatedAttribute);
          } else {
            return attributeGroup;
          }
        });
      } else {
        return [];
      }
    },
    updateEditOptionPricing: function updateEditOptionPricing(state, payload) {
      return state.setIn(['editCart', 'editOptions'], _updateEditOptionPricing(state.editCart.editOptions, payload));
    },
    updatePaymentInfo: function updatePaymentInfo(state, payload) {
      return state.setIn(['editCart', 'paymentInfo'], payload);
    },
    updatePhysicalInventoryMakeAndModel: function updatePhysicalInventoryMakeAndModel(state, _ref) {
      var pricingPlanId = _ref.pricingPlanId,
        inventoryId = _ref.inventoryId,
        makeId = _ref.makeId,
        modelId = _ref.modelId;
      var indexOfInventory = state[pricingPlanId].findIndex(function (item) {
        return item.id === inventoryId;
      });
      return state.setIn([pricingPlanId, indexOfInventory, 'selectedMake'], makeId).setIn([pricingPlanId, indexOfInventory, 'selectedModel'], modelId);
    },
    updatePhysicalInventoryTypeAttribute: function updatePhysicalInventoryTypeAttribute(state, _ref2) {
      var pricingPlanId = _ref2.pricingPlanId,
        inventoryId = _ref2.inventoryId,
        typeAttributeId = _ref2.typeAttributeId,
        value = _ref2.value;
      var indexOfInventory = state[pricingPlanId].findIndex(function (item) {
        return item.id === inventoryId;
      });
      return state.setIn([pricingPlanId, indexOfInventory, 'selectedTypeAttributes', typeAttributeId], value);
    },
    updateSelectedServiceFeatures: function updateSelectedServiceFeatures(attributeGroups, _ref3) {
      var attributeId = _ref3.attributeId,
        billerRuleInstanceDetails = _ref3.billerRuleInstanceDetails,
        selectedServiceFeatures = _ref3.selectedServiceFeatures;
      return attributeGroups.map(function (attributeGroup) {
        var attribute = attributeGroup.find(function (attribute) {
          return attribute.id === attributeId && attribute.serviceIdentifier;
        });
        return attribute ? updateGroupWith(attributeGroup, attribute.set('serviceFeatures', selectedServiceFeatures).set('billerRuleInstanceDetails', billerRuleInstanceDetails)) : attributeGroup;
      });
    }
  };
});
var _restoreDefaultOptionPricing = function _restoreDefaultOptionPricing(editOptions, optionId) {
  return editOptions.map(function (option) {
    if (option.Id !== optionId) {
      return option;
    } else {
      return Object.assign({}, option, {
        BillerRuleInstanceThumbnails: option.defaultAmounts
      });
    }
  });
};
var _setEditOption = function _setEditOption(editOptions, setOption) {
  // no edit options
  var updatedOptions = [];
  if (editOptions === null) {
    updatedOptions.push(Object.assign({}, setOption, {
      defaultAmounts: setOption.BillerRuleInstanceThumbnails,
      isPlanOrServiceSwap: setOption.isPlanOrServiceSwap
    }));
    return updatedOptions;
  }

  // new edit option does not exist in collection
  updatedOptions = editOptions.map(function (option) {
    return option;
  });
  var optionIds = pluck('Id')(editOptions);
  if (!contains(setOption.Id, optionIds)) {
    var newOption = Object.assign({}, setOption, {
      defaultAmounts: setOption.BillerRuleInstanceThumbnails,
      isPlanOrServiceSwap: setOption.isPlanOrServiceSwap
    });
    return updatedOptions.concat([newOption]);
  }

  // edit option already exists and just need update
  updatedOptions = editOptions.map(function (option) {
    return option.Id !== setOption.Id ? option : Object.assign({}, option, {
      BillerRuleInstanceThumbnails: setOption.BillerRuleInstanceThumbnails,
      BillerRuleDetails: setOption.BillerRuleDetails,
      isPlanOrServiceSwap: setOption.isPlanOrServiceSwap !== undefined ? setOption.isPlanOrServiceSwap : option.isPlanOrServiceSwap
    });
  });
  return updatedOptions;
};
var _updateEditOptionPricing = function _updateEditOptionPricing(editOptions, payload) {
  if (!editOptions || !Array.isArray(editOptions)) {
    return [];
  }
  var safePayload = Array.isArray(payload) ? payload : [];
  return editOptions.map(function (option) {
    var thumbnails = Array.isArray(option.BillerRuleInstanceThumbnails) ? option.BillerRuleInstanceThumbnails : [];
    return Object.assign({}, option, {
      BillerRuleInstanceThumbnails: thumbnails.map(function (bri, index) {
        var p = safePayload[index] || {};
        return Object.assign({}, bri, {
          pricingPeriods: p.pricingPeriods,
          financeOverrides: p.financeOverrides,
          scheduleType: p.scheduleType
        });
      })
    });
  });
};
var getAttribute = function getAttribute(attributeId, groups) {
  var decision = null;
  groups.forEach(function (group) {
    group.forEach(function (decisionValue) {
      if (decisionValue.id === attributeId) {
        decision = decisionValue;
      }
    });
  });
  return decision;
};